import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4d5c94a4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "p20 pl20"
};
const _hoisted_2 = {
  class: "alert"
};
const _hoisted_3 = {
  class: "pl20"
};
const _hoisted_4 = {
  class: "mt10 flex"
};
const _hoisted_5 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createTextVNode(" 发货成功，正在为您找车"), _createElementVNode("span", _hoisted_3, _toDisplayString($setup.data.viewNum) + "个承运人已查看", 1)]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.comps, (item, index) => {
    return _openBlock(), _createElementBlock("p", {
      onClick: () => $setup.changeTabs(index),
      class: _normalizeClass(['tab pointer', index == $setup.data.tabsIndex && 'active']),
      key: index
    }, _toDisplayString(item.label), 11, _hoisted_5);
  }), 128))]), (_openBlock(), _createBlock(_resolveDynamicComponent($setup.data.comps[$setup.data.tabsIndex].name), {
    demandId: $setup.data.demandId
  }, null, 8, ["demandId"]))]);
}